import { toast } from 'react-toastify'
import { useMutation } from '@tanstack/react-query'
import { Payment } from 'models/payments'
import { downloadFileFromData } from 'lib/helpers/utilities'
import { successToastOptions } from 'lib/utils/toast.utils'
import { IApiError } from 'services/Shared/shared.models'
import { TPaymentInvoiceFileTypeRequest } from 'services/Payments/payments.models'
import { getPaymentInvoice } from 'services/Payments/payments.services'

interface IuseDownloadPaymentInvoiceMutation {
  selectedWorkspaceId: number
  payment: Payment
  fileType: TPaymentInvoiceFileTypeRequest
}

const useDownloadPaymentInvoice = () => {
  const { icon, closeButton, ...loadingToastOptions } = successToastOptions

  const mutation = useMutation<
    string,
    IApiError,
    IuseDownloadPaymentInvoiceMutation
  >(
    ({ selectedWorkspaceId, payment, fileType }) => {
      if (!payment || !fileType) {
        throw new Error(
          'No hay suficiente información para descargar el archivo'
        )
      }

      return getPaymentInvoice(selectedWorkspaceId, payment, fileType)
    },
    {
      onMutate: () => {
        toast.loading('Descargando factura', {
          ...loadingToastOptions,
          toastId: 'loading',
        })
      },
      onSuccess: (file, variables) => {
        const { payment, fileType } = variables
        downloadFileFromData(
          `${payment?.uuid ?? 'XXXX0000-0000-XXXX-0000-XXXX0000XXXX'}.${fileType}`,
          file
        )
      },
      onError: () => {
        toast.error('No se pudo descargar la factura')
      },
      onSettled: () => toast.dismiss('loading'),
    }
  )

  return mutation
}

export default useDownloadPaymentInvoice
